import { saveAs } from 'file-saver';

export const handleFileDownload = (data, fileName) => {
    if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.handleBlobDownload
    ) {
        // Send the response data (assuming it's a blob) to Swift via message handler
        var blobData = new Blob([data], {
            type: 'application/octet-stream',
        });
        var reader = new FileReader();
        reader.onload = function() {
            var dataUrl = reader.result;
            console.log('Sending data to Swift via message handler');
            window.webkit.messageHandlers.handleBlobDownload.postMessage({
                base64String: dataUrl,
                fileName: fileName,
            });
        };

        reader.readAsDataURL(blobData);
    } else {
        console.log('Downloading data via browser', data, fileName);
        saveAs(data, fileName);
    }
};
